import { URL } from '../../../config'
import { getRequest, postRequest } from '../../../utils/functions/httpRequest'

export const getUsers = function (searchBy, searchValue,token) 
{
  const searchEndpoint = `/search`
  const criteria = typeof(searchValue) == 'number' ? searchValue.toString():searchValue
  // console.log('type of search value is', criteria, token)
  const  userURL =  `${URL.user}${searchEndpoint}/${searchBy}/${criteria}` 
  // console.log('userURL', userURL)
  return getRequest(userURL,'json',token)
}

export const approveUser = function (id,token) 
{
  const approveEndpoint = `/${id}/approveaccess`

  const   approveURL =  `${URL.user}${approveEndpoint}` 
  // console.log('userURL', approveURL)
  return postRequest(approveURL,'json',token)
}

export function denyUser(userRequestId, token) {
  const url = `${URL.user}/${userRequestId}/denyaccess`;
  return postRequest(url, null, token);
}

export const revokeAccess = function (id,token) 
{
  const revokeEndpoint = `/${id}/revokeaccess`

  const   approveURL =  `${URL.user}${revokeEndpoint}` 
  // console.log('userURL', approveURL)
  return postRequest(approveURL,'json',token)
}


// WEBPACK FOOTER //
// ./src/containers/userManagement/api/index.js